import { z } from 'zod';
/**
 * Mount intent: "get on my mount, or off it". No payload: the server knows
 * which mount is worn and whether the player is already riding.
 */
export const MountMessageSchema = z.object({}).strict();
/**
 * Summoning of the mount, to the owner alone: started (`durationMs` > 0) or
 * broken off / finished (`durationMs` = 0). The mount itself shows in the
 * public state once ridden.
 */
export const MountCastEventSchema = z
    .object({ durationMs: z.number().int().nonnegative() })
    .strict();
//# sourceMappingURL=mount.js.map